export var mapCrumbsToStaticCrumbs = function (crumbs) {
    return crumbs.map(function (crumb) {
        return {
            label: crumb.label,
            url: crumb.path || '',
        };
    });
};
